export interface StatsProps {
  data?: any;
  value?: any;
  bgColor?: any;
}
export function Stats(props: StatsProps) {
  console.log("print the color value", props.bgColor);
  return (
    <div
      className={`bg-${props?.bgColor} 2xl:w-56 2xl:h-44 xl:w-48 xl:h-36 drop-shadow-xl rounded-3xl flex flex-col items-center justify-center`}
    >
      <div className="2xl:text-6xl xl:text-5xl md:text-4xl font-bold text-center mb-2">
        {props.data!!}
      </div>
      <div className="2xl:text-lg xl:text-base font-bold text-center mt-2">
        {props.value!!}
      </div>
    </div>
  );
}
